import tenant from './tenant';
import product from './product';
import productDelayed from './productDelayed';
import ticketTypes from "./ticketTypes";

export default {
  namespaced: true,
  modules: {
    tenant,
    product,
    productDelayed,
    ticketTypes
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/tenants/index.js